// ==============================|| OVERRIDES - CARD / PAPER ||============================== //

export default function Card(theme) {
  const v = theme.vars.palette;
  return {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        rounded: { borderRadius: 8 },
        outlined: { borderColor: v.grey[200] }
      }
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { borderRadius: 8, border: `1px solid ${v.grey[200]}`, boxShadow: 'none' }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: { padding: '12px 16px' },
        title: { fontSize: '0.9375rem', fontWeight: 600, color: v.grey[800] },
        subheader: { fontSize: '0.8125rem' }
      }
    }
  };
}
